<h2 mat-dialog-title style="text-transform: uppercase">{{'AVANCES.ENCUESTA.LABEL11' | translate}}</h2>
<mat-dialog-content class="mat-typography">
    <p>{{'AVANCES.ACCIONES_EMAIL.INFO' | translate}} {{dataEmail.username}}</p>
    <mat-list role="list">
        <mat-list-item role="listitem">
            <mat-icon mat-list-icon>keyboard_arrow_right</mat-icon>
            <h4 mat-line>{{'AVANCES.ACCIONES_EMAIL.ACC1' | translate}}</h4>
            <button mat-mini-fab color="primary" class="m-5" (click)="send_email(1);" [disabled]="bloquearBtn || bloquear_Btn">
                <mat-icon>email</mat-icon>
            </button>
            <mat-divider></mat-divider>
        </mat-list-item>
        <mat-list-item role="listitem">
            <mat-icon mat-list-icon>keyboard_arrow_right</mat-icon>
            <h4 mat-line>{{'AVANCES.ACCIONES_EMAIL.ACC2' | translate}}</h4>
            <button mat-mini-fab color="primary" class="m-5" (click)="send_email(6);" [disabled]="bloquearBtn || bloquear_Btn">
                <mat-icon>email</mat-icon>
            </button>
            <mat-divider></mat-divider>
        </mat-list-item>
        <mat-list-item role="listitem">
            <mat-icon mat-list-icon>keyboard_arrow_right</mat-icon>
            <h4 mat-line>{{'AVANCES.ACCIONES_EMAIL.ACC3' | translate}}</h4>
            <button mat-mini-fab color="primary" class="m-5" (click)="borrar_respuestas()">
                <mat-icon>delete</mat-icon>
            </button>
            <mat-divider></mat-divider>
        </mat-list-item> <br>
        <mat-list-item role="listitem" *ngIf="informacionTemplate">
            <mat-icon mat-list-icon>keyboard_arrow_right</mat-icon>
            <h4>{{'CONSULTATABLA.LOG_SENDGRIND.TITULO' | translate}}</h4>
            <mat-form-field appearance="outline" style="width: 90%;">
                <mat-label>{{'CONSULTATABLA.LOG_SENDGRIND.OPCION' | translate}}</mat-label>
                <mat-select (selectionChange)="onChange($event)">
                    <mat-option *ngFor="let asunto of informacionTemplate" [value]="asunto">
                        {{asunto.asunto}}_{{asunto.tipo}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <button mat-mini-fab color="primary" class="m-5" matTooltip="{{'CONSULTATABLA.LOG_SENDGRIND.TOOLTIP' | translate}}" (click)="getEmail()">
                <mat-icon>search</mat-icon>
            </button>
            <mat-divider></mat-divider>
        </mat-list-item>
    </mat-list>
</mat-dialog-content>
